import(/* webpackMode: "eager", webpackExports: ["SafePlasmicComponent"] */ "/app/next/src/components/plasmic/SafePlasmicComponent.tsx");
